import { ListingColDefs } from './listing-col-defs';

/**
 * Class for constructing column defs for Unregistered Listing Data
 *
 * @export
 * @class UnregisteredColDefs
 * @extends {ListingColDefs}
 */
export class UnregisteredColDefs extends ListingColDefs {
  /**
   * Groups of columns for Unregistered dataset
   *
   * @override
   */
  columnGroups() {
    return [
      this.propertyDetailsColGroup,
      this.listingsInfoColGroup,
      this.occupancyComplianceColGroup,
      this.longTermStayComplianceColGroup,
      this.bedroomInfoColGroup,
      this.otherInfoColGroup,
      this.bookingInfoColGroup,
    ];
  }
}
